import React, { useState } from 'react';
import Button from '../../../ui/Button/Button';
import { Field, Input, FormFooter } from '../../../ui/Field/Field';
import useDraft from '../../../ui/Field/useDraft';
import { custodyService } from '../../../services/custodyService';

const CustodyForm = ({ onSuccess, onCancel }) => {
    // New-custody form: kept as a draft in this browser until it is saved.
    const [formData, setFormData, draft] = useDraft('draft:new-custody', {
        name: '',
        total_amount: '',
        open_date: new Date().toISOString().split('T')[0]
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.name || !formData.total_amount) {
            setError('Please fill in Name and Amount.');
            return;
        }

        setLoading(true);
        const res = await custodyService.createCustody(formData);
        setLoading(false);

        if (res.success) {
            draft.clear();
            onSuccess();
        } else {
            setError('Failed to create custody.');
        }
    };

    // Required fields are checked by handleSubmit (same message as before), so the inputs
    // carry aria-required instead of the native `required` attribute.
    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2" role="alert">{error}</div>}

            <Field label="Custody Name" required>
                <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="e.g. Petty Cash - Dubai Office"
                    required={false}
                    aria-required="true"
                />
            </Field>

            <Field label="Opening Balance" required>
                <Input
                    type="number"
                    name="total_amount"
                    value={formData.total_amount}
                    onChange={handleChange}
                    placeholder="0.00"
                    suffix="AED"
                    required={false}
                    aria-required="true"
                />
            </Field>

            <Field label="Open Date">
                <Input
                    type="date"
                    name="open_date"
                    value={formData.open_date}
                    onChange={handleChange}
                />
            </Field>

            <FormFooter sticky={false} status={draft.status}>
                <Button type="button" onClick={onCancel}>Cancel</Button>
                <Button type="submit" variant="primary" isLoading={loading}>Create Custody</Button>
            </FormFooter>
        </form>
    );
};

export default CustodyForm;
